<template>
    <div id="ActivityMobile">
        <ActivityMobileFilter></ActivityMobileFilter>
        <div class="activities-wrap">
            <ActivityItem
                v-for="(item, index) in beachSearchData"
                :key="'activity-item-' + index"
                :item="item"
            ></ActivityItem>
        </div>
        <div class="pagination-wrap">
            <ElPagination
                layout="prev, pager, next"
                :total="totalBeachSearchData"
                :page-size="10"
                v-model:currentPage="queryItems.pageIndex"
                @update:current-page="
                    updateRoute('pageIndex', queryItems.pageIndex)
                "
                prev-text="上一頁"
                next-text="下一頁"
            >
            </ElPagination>
        </div>
    </div>
</template>
<script>
export default {
    name: 'ActivityMobile',
}
</script>
<script setup>
import { reactive, ref } from 'vue'
import { onBeforeRouteUpdate, useRoute } from 'vue-router'
import ActivityMobileFilter from './ActivityMobileFilter.vue'
import ActivityItem from './ActivityItem.vue'
import { ElPagination } from 'element-plus'
import { getBeachActivities } from '@/service/apis.js'
import { initQueryItems, updateRoute } from '@/utils/query.js'
const route = useRoute()

onBeforeRouteUpdate((to) => {
    initBeachSearchData(to.query)
    initQueryItems(queryItems, to.query)
    window.scroll({
        top: 0,
        left: 0,
    })
})
const beachSearchData = ref([])
const totalBeachSearchData = ref(0)
async function initBeachSearchData(query) {
    let res = await getBeachActivities(query)
    beachSearchData.value = res.beachActivities
    totalBeachSearchData.value = res.totalCount
    // console.log(beachSearchData.value)
    // console.log(totalBeachSearchData.value)
}
initBeachSearchData(route.query)

// 初始化 query 數據
const queryItems = reactive({
    pageIndex: 1,
})
initQueryItems(queryItems)
</script>
<style lang="scss" scoped>
#ActivityMobile {
    position: sticky;
}
.activities-wrap {
    padding: 1px 0;
    background-color: $grayF;
}
.pagination-wrap {
    margin: 30px 0;
    display: flex;
    justify-content: center;
    .el-pagination:deep() {
        button:focus-visible {
            outline: auto;
        }
        .el-pager {
            li {
                color: $gray6;
                font-size: 500;
            }
            li.is-active {
                color: $white;
                background-color: $theme1;
                border-radius: 50%;
            }
        }
    }
}
</style>
